export const isItemAllowed = (itemId, items, 
/** @deprecated Remove in the next major release */
disabledChains) => {
    if (items?.allow?.length) {
        return items.allow.includes(itemId);
    }
    return !(disabledChains?.includes(itemId) || items?.deny?.includes(itemId));
};
